import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { SearchBranch } from '../../../external/AggregationApi';
import { actions } from '../../modules/Actions';

export const initialSearchBranchPendingState: { [key: string]: SearchBranch } = {};

export const searchBranchPendingReducer = reducerWithInitialState(initialSearchBranchPendingState).case(
  actions.updateSearchBranch.pending,
  (state: { [key: string]: SearchBranch }, payload: { [key: string]: SearchBranch }) => {
    return {
      ...state,
      ...payload,
    };
  }
);
